import React from 'react'
import axios from 'axios'
import 'react-toolbox/lib/colors.css'
import './styles/base.scss'
import Root from './containers/Root'
import { setConfig } from './utils/config'
import { init as initAPI } from './utils/api'
import { render } from 'react-dom'
import constants from 'constants'

axios.get(`${window.location.origin}/config.json`)
  .then(({ data: config }) => {
    // Update configuration
    const RedirectUrl = sessionStorage.getItem('RedirectUrl')
    if (!RedirectUrl) {
      sessionStorage.setItem('RedirectUrl', window.location)
    }
    setConfig(config)
    // Initialize API library
    initAPI()
    const isAuthenticated = JSON.parse(sessionStorage.getItem('IsAuthenticated'))
    const sharepointToken = JSON.parse(sessionStorage.getItem('SharepointToken'))
    if (isAuthenticated && sharepointToken) {
      // Render page
      render(
        <Root />,
        document.getElementById('root'),
      )
    } else {
      if (window.location.hash.indexOf('code') > -1 || window.location.search.indexOf('code') > -1) {
        const urlParams = new URLSearchParams(window.location.search)
        const myParam = urlParams.get('code')
        if (isAuthenticated) {
          if (sharepointToken) {
            window.location = config.redirectUri
          } else {
            axios.post(`${config.SPAccessUrl}${myParam}`, '')
              .then((spApiResp) => {
                if (spApiResp.data.toLowerCase() === 'token received') {
                  sessionStorage.setItem('SharepointToken', 'true')
                  window.location = config.redirectUri
                } else {
                  document.body.innerHTML = constants.ERROR_HTML.ACCESS_DENIED
                  console.error('User not authenticated from SharePoint, please check access.')
                  // document.body.innerHTML = '<div style=\'font-weight:bold;padding-left: 10px;padding-top: 10px; color: red;\'>Unauthorised.</div>'
                }
              })
              .catch((error) => {
                document.body.innerHTML = constants.ERROR_HTML.ERROR_OCCURED
                console.error('Could be authenticated to SharePoint, please check SharePoint access.')
              })
          }
        } else {
          axios.post(`${config.UserAccessUrl}${myParam}`, '')
            .then((apiResp) => {
              if (apiResp.data.EmployeeId != null && apiResp.data.EmployeeId >= 0) {
                sessionStorage.setItem('IsAuthenticated', 'true')
                sessionStorage.setItem('CurrentUser', JSON.stringify(apiResp.data))
                window.location = config.sharePointLoginUrl
              } else {
                if (apiResp.data.toLowerCase().indexOf('authentication') > 0) {
                  document.body.innerHTML = constants.ERROR_HTML.ACCESS_DENIED
                } else {
                  document.body.innerHTML = constants.ERROR_HTML.ERROR_OCCURED
                }
                console.error('Unauthorise access. Unable to retrieve employee detail from Azure AD.')
                // document.body.innerHTML = '<div style=\'font-weight:bold;padding-left: 10px;padding-top: 10px; color: red;\'>You do not have access on this application.</div>'
              }
            })
            .catch((error) => {
              if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // (`1:${error}`)
                // (`2:${error.response.data}`)
                // (`3:${error.response.status}`)
                // (`4:${error.response.headers}`)
                if (error.response.data.toLowerCase().indexOf('authentication') > 0) {
                  document.body.innerHTML = constants.ERROR_HTML.ACCESS_DENIED
                }
              } else {
                // Something happened in setting up the request that triggered an Error
                document.body.innerHTML = constants.ERROR_HTML.ERROR_OCCURED
                console.error('Could not connect to api, please check web api or database connectivity.')
              }
            })
        }
        // axios.post(`${config.UserAccessUrl}${myParam}`, '')
        //   .then((apiResp) => {
        //     ('response:', apiResp)
        //     if (isAuthenticated && sharepointToken) {
        //       window.location = config.redirectUri
        //     } else if (isAuthenticated && spTokenReq) {

        //     }
        //     else if (isAuthenticated && !sharepointToken) {
        //       window.location = config.sharePointLoginUrl
        //     } else {
        //       if (apiResp.data.EmployeeId != null && apiResp.data.EmployeeId > 0) {
        //         sessionStorage.setItem('IsAuthenticated', 'true')
        //         sessionStorage.setItem('CurrentUser', JSON.stringify(apiResp.data))

        //       }
        //     }
        //   })
        //   .catch((error) => {
        //     console.error(`Could not connect to api: ${error}`)
        //   })
      } else {
        window.location = config.loginUrl
      }
    }
  })
  .catch((error) => {
    console.error('Could not load website config, please check.')
    document.body.innerHTML = constants.ERROR_HTML.ERROR_OCCURED
  })




// WEBPACK FOOTER //
// ./src/index.js